export enum EnrollmentTypeEnum {
  RegularEnrollment = 1,
  SubsequentEnrollment = 2,
}
